<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <smr-menu-button></smr-menu-button>
    </ion-buttons>
    <ion-title>
      Suppliers
    </ion-title>
    <ion-buttons slot="end" *ngIf="!isMobile">
      <ion-button
        fill="outline"
        expand="block"
        color="primary"
        [disabled]="isLoading || errorOccurredWhileLoadingProducts"
        (click)="create()"
      >
        <ion-icon name="add"></ion-icon>New Supplier
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-text-center ion-padding">
  <ng-container
    *ngIf="!(isLoading || errorOccurredWhileLoadingProducts)"
  >
    <div *ngIf="productSuppliers.count() == 0" class="smr-empty-state ion-padding">
      <img src="./assets/images/no-suppliers.png" />
      <h4>No suppliers have been entered yet.</h4>
      You can enter your suppliers to help order products.
      <br /><br /><br />
      <ion-button outline (click)="create()">
        + Enter your first supplier
      </ion-button>
    </div>

    <ion-list>
      <ion-item
        *ngFor="let productSupplier of productSuppliers"
        (click)="edit(productSupplier)"
        tappable
      >
        {{ productSupplier.name }}
      </ion-item>
    </ion-list>
  </ng-container>

  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingProducts"
    (click)="onTapToReload()"
  ></salonmonster-tap-retry>


  <ion-fab
    slot="fixed"
    vertical="bottom"
    horizontal="end"
    *ngIf="isMobile"
    (click)="create()"
  >
    <ion-fab-button>
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>
